const RESPONSE_DISPLAY_LIMIT = 20_000;

export class ApiResponseError extends Error {
  readonly status: number;
  readonly statusText: string;
  readonly responseBody: string;

  constructor(message: string, response: Response, responseBody: string) {
    super(message);
    this.name = "ApiResponseError";
    this.status = response.status;
    this.statusText = response.statusText;
    this.responseBody = responseBody;
  }
}

function payloadError(payload: unknown): string {
  if (!payload || typeof payload !== "object" || Array.isArray(payload) || !("error" in payload)) return "";
  const value = payload.error;
  return value ? String(value) : "";
}

export async function readApiResponse(response: Response): Promise<unknown> {
  const responseBody = await response.text();
  let payload: unknown = null;
  if (responseBody) {
    try {
      payload = JSON.parse(responseBody) as unknown;
    } catch {
      payload = responseBody;
    }
  }

  const serverError = payloadError(payload);
  if (!response.ok || serverError) {
    const status = `HTTP ${response.status}${response.statusText ? ` ${response.statusText}` : ""}`;
    throw new ApiResponseError(serverError || status, response, responseBody);
  }
  return payload;
}

export interface SendFailureDetails {
  message: string;
  response: string;
}

export function describeSendFailure(error: unknown): SendFailureDetails {
  const message = error instanceof Error ? error.message : String(error);
  if (!(error instanceof ApiResponseError)) {
    return {
      message,
      response: "レスポンスを受信できませんでした。",
    };
  }

  const status = `HTTP ${error.status}${error.statusText ? ` ${error.statusText}` : ""}`;
  const body = error.responseBody || "（空のレスポンス）";
  const response = `${status}\n\n${body}`;
  return {
    message,
    response: response.length > RESPONSE_DISPLAY_LIMIT
      ? `${response.slice(0, RESPONSE_DISPLAY_LIMIT)}\n…（以下省略）`
      : response,
  };
}
